import { createContext } from "../../util/create-context.js";
export const [FileUploadLocaleContextProvider, useFileUploadTranslation] = createContext();
//# sourceMappingURL=FileUpload.context.js.map